import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import Breadcrumb from './Breadcrumb.js';
import { Breadcrumbs as Breadcrumbs$2 } from './style.js';
import { createElement } from 'react';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["links"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Breadcrumbs = function Breadcrumbs(_ref) {
  var links = _ref.links,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!Array.isArray(links) || links.length < 1) {
    return false;
  }
  var PotentialChildren = links.map(function (link, i) {
    return /*#__PURE__*/createElement(Breadcrumb, _objectSpread(_objectSpread({}, link), {}, {
      position: i + 1,
      key: i
    }));
  }).filter(function (v) {
    return v;
  });
  if (!PotentialChildren.length) {
    return false;
  }
  return /*#__PURE__*/jsx(Breadcrumbs$2, _objectSpread(_objectSpread({
    itemScope: true,
    itemType: "https://schema.org/BreadcrumbList"
  }, rest), {}, {
    children: PotentialChildren
  }));
};
var Breadcrumbs$1 = Breadcrumbs;

export { Breadcrumbs$1 as default };
//# sourceMappingURL=Breadcrumbs.js.map
